import { List, Map } from 'immutable'
import _kebabCase from 'lodash/kebabCase'
import { ICON_TYPES } from '../Icon.v2/index'
import { TOPIC_CLICKED_GA4_EVENT } from '../../services/event-tracking/index'

export const uiLocation = 'Topics'
export const uiElement = 'Topic Link'

export function getTopicGA4Data (options) {
  const { tid, name } = options

  return TOPIC_CLICKED_GA4_EVENT
    .mergeDeep({
      topic_name: name,
      topic_id: tid,
      ui_element: uiElement,
      ui_location: uiLocation,
    })
}

function formatColumnsData (sectionIds, numInRow) {
  return sectionIds.reduce((acc, sectionId, index) => {
    if (index < numInRow) {
      return acc.push(List([sectionId]))
    }
    return acc.withMutations((mutateState) => mutateState.update(
      index % numInRow,
      List([]),
      (updateState) => {
        return updateState.push(sectionId)
      },
    ))
  }, List([]))
}

/* eslint-disable import/prefer-default-export */
export function formatSectionData (options = {}) {
  const {
    sectionIds = List(),
    viewportWidth,
  } = options

  if (!List.isList(sectionIds)) {
    return List()
  }

  // smallest viewport
  if (viewportWidth < 480) {
    return sectionIds.reduce((acc, sectionId) => {
      return acc.push(List([sectionId]))
    }, List([]))
  }

  // large phone / small tablet size viewport
  if (viewportWidth >= 480 && viewportWidth < 768) {
    return formatColumnsData(sectionIds, 2)
  }

  // large tablet / small laptop
  if (viewportWidth >= 768 && viewportWidth < 944) {
    return formatColumnsData(sectionIds, 3)
  }

  // large tablet / small laptop
  if (viewportWidth >= 944 && viewportWidth < 1440) {
    return formatColumnsData(sectionIds, 4)
  }

  // widescreen viewport
  return formatColumnsData(sectionIds, 5)
}

export function getIconTypeByLabel (label) {
  const key = _kebabCase(label)
  switch (key) {
    case 'gaias-collections':
      return ICON_TYPES.HEALING
    case 'health':
      return ICON_TYPES.HEALTH
    case 'yoga':
      return ICON_TYPES.YOGA_2
    case 'meditation':
      return ICON_TYPES.CONSCIOUSNESS
    case 'spiritual-growth':
      return ICON_TYPES.GROWTH
    case 'expanded-consciousness':
      return ICON_TYPES.MIND
    case 'hidden-history':
      return ICON_TYPES.ORIGINS
    case 'supernatural':
      return ICON_TYPES.SUPERNATURAL
    case 'unexplained':
      return ICON_TYPES.SECRETS
    case 'coverups':
      return ICON_TYPES.COVERUPS
    default:
      return null
  }
}

export const yogaStaticTopics = Map({
  en: [
    {
      to: '/yoga',
      label: 'Yoga Home',
    },
    {
      to: '/yoga/teachers',
      label: 'Yoga Teachers',
    },
    {
      to: 'https://www.gaia.com/articles/yoga-poses',
      label: 'Yoga Pose Library',
    },
  ],
  es: [
    {
      to: '/yoga',
      label: 'Yoga Home',
    },
    {
      to: 'https://www.gaia.com/es/articles/yoga-poses',
      label: 'Posturas de Yoga',
    },
  ],
  de: [],
  fr: [],
})
